import { Pipe, type PipeTransform } from '@angular/core';
import { Logger } from './logger';

const logger = Logger.get('intlCurrency');

/**
 * Because angular currency pipe doesn't show currency symbol if locale doesn't match currency code.
 * Example: for 'en-US' locale the euro symbol won't be shown.
 */
@Pipe({ name: 'intlCurrency', standalone: true, pure: true })
export class IntlCurrency implements PipeTransform {
  transform(amount: number | string, currencyCode: string): string {
    if (typeof amount === 'string') {
      amount = parseFloat(amount);
    }

    return convert(amount, currencyCode);
  }
}

@Pipe({ name: 'intlCurrencyMinor', standalone: true, pure: true })
export class IntlCurrencyMinor implements PipeTransform {
  transform(amountInMinor: number, currencyCode: string): string {
    return convert(amountInMinor / 100, currencyCode);
  }
}

function convert(amountInMajor: number, currencyCode: string): string {
  if (currencyCode == null || currencyCode.trim().length === 0) {
    logger.warn('No currency code given. Returning formatted number without currency.');
    return new Intl.NumberFormat(window.navigator.language).format(amountInMajor);
  }

  const options: Intl.NumberFormatOptions = { style: 'currency', currency: currencyCode };
  return new Intl.NumberFormat(window.navigator.language, options).format(amountInMajor).replace(/ /g, '\u2009');
}
